import I18n from "common/i18n";
import { PlanType } from "features/subscription";

interface PlanBadgeProps {
  plan: PlanType;
  size?: "small" | "normal";
  forParent?: boolean;
}

const getPlanColor = (plan: PlanType): string => {
  switch (plan) {
    case PlanType.TRIAL:
      return "#9E9E9E"; // Gray for Trial
    case PlanType.FREE:
      return "#4C9DF1"; // Blue for Free
    case PlanType.EDUCATION:
      return "#3E5878"; // Navy for Education
    case PlanType.STANDARD:
      return "#66BB6A"; // Green for Standard
    case PlanType.PREMIUM:
      return "#FF5722"; // Deep Orange for Premium
    case PlanType.BUILDER:
      return "#9C27B0"; // Purple for Builder
    default:
      return "#9E9E9E"; // Gray for unknown
  }
};

const getPlanI18nKey = (plan: PlanType, forParent?: boolean): string => {
  const suffix = forParent ? "_PARENT" : "";
  switch (plan) {
    case PlanType.TRIAL:
      return `MSG_PLAN_TRIAL${suffix}`;
    case PlanType.FREE:
      return `MSG_PLAN_FREE${suffix}`;
    case PlanType.STANDARD:
      return `MSG_PLAN_STANDARD${suffix}`;
    case PlanType.PREMIUM:
      return `MSG_PLAN_PREMIUM${suffix}`;
    case PlanType.BUILDER:
      return `MSG_PLAN_BUILDER${suffix}`;
    case PlanType.EDUCATION:
      return `MSG_PLAN_EDUCATION${suffix}`;
    default:
      return `MSG_PLAN_UNKNOWN${suffix}`;
  }
};

export const PlanBadge = ({ plan, size = "normal", forParent = false }: PlanBadgeProps) => {
  const backgroundColor = getPlanColor(plan);
  const i18nKey = getPlanI18nKey(plan, forParent);

  return (
    <div className="flex-row-el flex-center rounded-full p-2" style={{ backgroundColor }}>
      <div className="flex-row-el flex-center">
        <div className="flex-col-center w-[24px] h-[24px] rounded-full mr-1 bg-white">
          <span className="material-symbols-outlined !text-base" style={{ color: backgroundColor }}>
            workspace_premium
          </span>
        </div>
        <p className="text-body text-xl text-white">{I18n.t(i18nKey)}</p>
      </div>
    </div>
  );
};
